import { render } from "./FinanzasAdmin.vue?vue&type=template&id=ff2d19c4&scoped=true"
import script from "./FinanzasAdmin.vue?vue&type=script&lang=js"
export * from "./FinanzasAdmin.vue?vue&type=script&lang=js"

import "./FinanzasAdmin.vue?vue&type=style&index=0&id=ff2d19c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff2d19c4"]])

export default __exports__